var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletActiveIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5495 2.09877L10.5245 2.15711L8.10781 7.76544H5.73281C5.16615 7.76544 4.62448 7.88211 4.13281 8.09044L5.59115 4.60711L5.62448 4.52377L5.68281 4.39044C5.69948 4.34044 5.71615 4.29044 5.74115 4.24877C6.83281 1.72377 8.06615 1.14877 10.5495 2.09877Z",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0427 7.93197C14.6677 7.8153 14.2677 7.7653 13.8677 7.7653H8.10938L10.526 2.15697L10.551 2.09863C10.676 2.1403 10.7927 2.19863 10.9177 2.24863L12.7594 3.02363C13.7844 3.44863 14.501 3.8903 14.9344 4.42363C15.0177 4.52363 15.0844 4.6153 15.1427 4.72363C15.2177 4.8403 15.276 4.95697 15.3094 5.08197C15.3427 5.15697 15.3677 5.23197 15.3844 5.29863C15.6094 5.99863 15.476 6.85697 15.0427 7.93197Z",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9341 11.8323V13.4573C17.9341 13.624 17.9258 13.7906 17.9174 13.9573C17.7591 16.8656 16.1341 18.3323 13.0508 18.3323H6.55078C6.35078 18.3323 6.15078 18.3156 5.95911 18.2906C3.30911 18.1156 1.89245 16.699 1.71745 14.049C1.69245 13.8573 1.67578 13.6573 1.67578 13.4573V11.8323C1.67578 10.1573 2.69245 8.71563 4.14245 8.09063C4.64245 7.88229 5.17578 7.76562 5.74245 7.76562H13.8758C14.2841 7.76562 14.6841 7.82396 15.0508 7.93229C16.7091 8.44063 17.9341 9.99063 17.9341 11.8323Z",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59297 4.60742L4.13464 8.09075C2.68464 8.71575 1.66797 10.1574 1.66797 11.8324V9.39076C1.66797 7.02409 3.3513 5.04909 5.59297 4.60742Z",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9302 9.38939V11.8311C17.9302 9.99772 16.7135 8.43939 15.0469 7.93939C15.4802 6.85605 15.6052 6.00605 15.3969 5.29772C15.3802 5.22272 15.3552 5.14772 15.3219 5.08105C16.8719 5.88105 17.9302 7.52272 17.9302 9.38939Z",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.3252L9.08653 15.0003L12.5 11.667",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletActiveIcon);
export default __webpack_public_path__ + "static/media/walletActiveIcon.f2438cb44d2235f07005d84effe08be8.svg";
export { ForwardRef as ReactComponent };